var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"tel:" + _vm.number,"target":"_self","aria-label":"\"call \" + number"}},[_vm._v(_vm._s(_vm.formatedPhone))])}
var staticRenderFns = []

export { render, staticRenderFns }